<template>
  <model-form
    :model="jobLog"
    modal-type="modal"
    :read-only="true"
  >
    <div class="row q-col-gutter-sm q-mt-lg">
      <q-input
        v-model="jobLog.summary"
        class="col-12"
        label="Summary"
        type="textarea"
        readonly
      />
      <q-input
        v-model="jobLog.log"
        class="col-12"
        label="Log"
        type="textarea"
        readonly
      />
    </div>
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'JobLoggerForm',
  components: {
    ModelForm
  },
  models: {
    jobLog: 'default'
  }
}

</script>
